

<p-chart type="doughnut" height="300" [options]="options" [data]="data"></p-chart>